export default __webpack_public_path__ + "static/creator-illustration-light-34b0362498566e60688a02e784e6a084.svg";